module.exports = __webpack_public_path__ + "static/img/hello.c01cbb60.png";